// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"251":"5e2b4721","416":"66247294","791":"d6e00f18"}[chunkId] + ".js";
};